module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error404"
  }, [_c('div', {
    staticClass: "error404-body-con"
  }, [_c('Card', [_c('div', {
    staticClass: "error404-body-con-title"
  }, [_vm._v("4"), _c('span', [_c('Icon', {
    attrs: {
      "type": "ios-navigate-outline"
    }
  })], 1), _vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "error404-body-con-message"
  }, [_vm._v("YOU  LOOK  LOST")]), _vm._v(" "), _c('div', {
    staticClass: "error404-btn-con"
  }, [_c('Button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "large",
      "type": "text"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "200px",
      "margin-left": "40px"
    },
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v("返回上一页")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-491686f8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/views/404.vue
// module id = M5Z/
// module chunks = 0